export default __webpack_public_path__ + "static/media/Hrishikesh.cc5a3909.jpeg";